import { Store } from '@ms/yammer-data/dist/state/types';
import { PageSectionRefsProvider } from '@ms/yammer-web-components/dist/app/PageSectionRefs';
import { ReduxTranslationsContextProvider } from '@ms/yammer-web-components/dist/translations';
import { AnnouncerProvider } from '@ms/yammer-web-core-ui/dist/components/Announcer';
import React from 'react';
import { render } from 'react-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { Persistor } from 'redux-persist';
import { PersistGate } from 'redux-persist/integration/react';

import App from '../../../components/App';
import { YammerWebState } from '../../../state/types';

import { getBasename } from './getBasename';
import { getErrorComponent } from './getErrorComponent';

export interface RendererOptions {
  readonly store: Store<YammerWebState>;
  readonly target: HTMLElement;
  readonly persistor?: Persistor;
  readonly isFailure?: boolean;
}

export type Renderer = (options: RendererOptions) => void;

const renderer: Renderer = ({ store, target, persistor, isFailure = false }) => {
  const children = isFailure ? getErrorComponent(store) : <App />;

  const basename = getBasename(store);

  const content = (
    <HelmetProvider>
      <BrowserRouter basename={basename}>
        <PageSectionRefsProvider>
          <AnnouncerProvider>{children}</AnnouncerProvider>
        </PageSectionRefsProvider>
      </BrowserRouter>
    </HelmetProvider>
  );

  const contentWithOptionalPersistGate = persistor ? (
    <PersistGate loading={null} persistor={persistor}>
      {content}
    </PersistGate>
  ) : (
    content
  );

  render(
    <Provider store={store}>
      <ReduxTranslationsContextProvider>{contentWithOptionalPersistGate}</ReduxTranslationsContextProvider>
    </Provider>,
    target
  );
};

export default renderer;
